export const APP_PREFIX = {
    COPILOT: 'redtrack-copilot',
    CLIENT_APP: '',
    ADMIN: 'admin',
    PUB: 'pub',
    ADVERT: 'advert',
};
//# sourceMappingURL=auth.js.map